import React from "react";
import classNames from "classnames";

import GenericField from "../generic-field/GenericField.jsx";
import InputTextarea from "../input-textarea/InputTextareaController.jsx";
import "./styles.styl";

export default function FieldSelect(props) {
  const { className, ...rest } = props;

  return (
    <GenericField
      className={classNames("field-text", className)}
      InputComponent={InputTextarea}
      {...rest}
    />
  );
}
